import React, { Component, Fragment } from 'react';
import { Table, InputNumber, Input, Tag, Space, Select, Form, DatePicker, message, Switch, Drawer, Popconfirm, Collapse, Button, Row, Col, Divider, Card } from "antd";
import { getGeneratorMasterData, Creategenerator, getGeneratorDetails, getGeneratorBySiteId, Updategenerator, getBulckTankBySiteId, dataUpdateGeneralDetails } from "../../api/index";
import SimpleReactValidator from "simple-react-validator";
import checkPermissions from '../../utils/permissionManager';
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, EyeOutlined, PlusCircleOutlined, HomeOutlined } from '@ant-design/icons';
import moment from 'moment';
import AssetDelete from "./asset_delete";
import { checkServiceType } from "../../actions/service-type";


class GeneratorDetails extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            open: false,
            openEdit: false,
            openGenDetails: false,
            selectedGenerator: "",
            title: "",
            assetsList: null,
            modelList: null,
            categoriesList: null,
            tankTypesList: null,
            showModal: false,
            generatorIsActive: null,
            genName: '',
            genDescription: '',
            genCapacity: '',
            genStatus: '',
            genMaxFillingLimit: '',
            selectedGenBulckTankId: null,
            GenBulckTanktype: [],
            selectedGeneratorAssetId: null,
            generatorAssetType: [],
            selectedGeneratormodelId: null,
            generatorModelId: [],
            selectedGeneratorMakeId: null,
            generatorMakeId: [],
            selectedGeneratorCategory: null,
            generatorCategoryType: [],
            WarrantyExpiredDate: null,
            SAPSerialNumber: '',
            engineSerialNumber: '',
            alternaterSerialNumber: '',
            controllerSerialNumber: '',
            anyOtherSerialNumber: '',
            materialCodeOfTheGenerator: '',
            siteGeneratorList: null,
            selectGenId: '',
            Alldataview: null,
            bulckTankList: [],
            actionView: false,
            genEdit: null,
            AssetManagementPermission: false,


            phase1Load: '',
            phase2Load: '',
            phase3Load: '',
            loadingWithBatteryCharging: '',
            loadingWithoutBatteryCharging: '',
            actualFuelConsumptionRate: '',
            availabilityOfGenCanapy: null,
            genCanapyStatus: '',
            soundProofStatus: '',
            delayTimerStatus: '',
            generatorWormUpDelayTime: '',
            rmsintegratedStatus: '',
            rms: '',
            rmsconnectionMethod: '',
            rmsrelatedSIMNumber: '',
            rmsInbandOutband: '',
            installedDate: null,
            lastServicedDate: null,
            generatorControllerModel: '',
            availableFuelQty: '',
            generatorCoolDownDelayTime: '',
            engineModel: '',
            genAverageRunningHourspermonth: '',
            engineModel: '',
            engineControllerModel: '',
            avrModel: '',
            fuelTankCapacity: '',
            hourMeterReading: '',

            isUpadetQuery : false,

            switchStatus: true,
            objectSet: {
                "genTicketNumberOfPendingFaultyTicket": 0,
            },

            generatorDropDownObject: {
                "generatorControllerModel": "",
                "avrModel": "",
                "fuelTankCapacity": "",
                "availabilityOfGenCanapy": "",
                "genCanapyStatus": "",
                "soundProofStatus": "",
                "delayTimerStatus": "",
                "rmsintegratedStatus": "",
                "rmsInbandOutband": "",
                "rmsConnectionMethod": "",
            }
        };
        this.requestFromClose = this.requestFromClose.bind(this);
        this.grnView = this.grnView.bind(this);
        this.requestFromClose2 = this.requestFromClose2.bind(this);
        this.requestFromClose3 = this.requestFromClose3.bind(this);
        this.handleGenName = this.handleGenName.bind(this);
        this.handleGenDescription = this.handleGenDescription.bind(this);
        this.handleMaxFillingLimit = this.handleMaxFillingLimit.bind(this);
        this.handleGenCapacity = this.handleGenCapacity.bind(this);
        this.handleGenStatus = this.handleGenStatus.bind(this);
        this.handleGenSAPSerialNumber = this.handleGenSAPSerialNumber.bind(this);
        this.handleEngineSerialNumber = this.handleEngineSerialNumber.bind(this);
        this.handleAlternaterSerialNumber = this.handleAlternaterSerialNumber.bind(this);
        this.handleControllerSerialNumber = this.handleControllerSerialNumber.bind(this);
        this.handleAnyOtherSerialNumber = this.handleAnyOtherSerialNumber.bind(this);
        this.handleMaterialCodeOfTheGenerator = this.handleMaterialCodeOfTheGenerator.bind(this);
        this.handlephase1Load = this.handlephase1Load.bind(this);
        this.handlephase2Load = this.handlephase2Load.bind(this);
        this.handlephase3Load = this.handlephase3Load.bind(this);
        this.handleloadingWithBatteryCharging = this.handleloadingWithBatteryCharging.bind(this);
        this.handleloadingWithoutBatteryCharging = this.handleloadingWithoutBatteryCharging.bind(this);
        this.handleactualFuelConsumptionRate = this.handleactualFuelConsumptionRate.bind(this);
        this.handlegenCanapyStatus = this.handlegenCanapyStatus.bind(this);
        this.handlesoundProofStatus = this.handlesoundProofStatus.bind(this);
        this.handlDelayTimerStatus = this.handlDelayTimerStatus.bind(this);
        this.handlegeneratorWormUpDelayTime = this.handlegeneratorWormUpDelayTime.bind(this);
        this.handlermsintegratedStatus = this.handlermsintegratedStatus.bind(this);
        this.handlerMS = this.handlerMS.bind(this);
        this.handlermsconnectionMethod = this.handlermsconnectionMethod.bind(this);
        this.handlerMSRelatedSIMNumber = this.handlerMSRelatedSIMNumber.bind(this);
        this.handlerMsInbandOutband = this.handlerMsInbandOutband.bind(this);
        this.handlegeneratorControllerModel = this.handlegeneratorControllerModel.bind(this);
        this.handleavailableFuelQty = this.handleavailableFuelQty.bind(this);
        this.handlefuelTankCapacity = this.handlefuelTankCapacity.bind(this);
        this.handlehourMeterReading = this.handlehourMeterReading.bind(this);
        this.handlegeneratorCoolDownDelayTime = this.handlegeneratorCoolDownDelayTime.bind(this);
        this.handlegeneratorEngineModel = this.handlegeneratorEngineModel.bind(this);
        this.handlegeneratorAVRModel = this.handlegeneratorAVRModel.bind(this);
        this.handlAverageRunningHourspermonth = this.handlAverageRunningHourspermonth.bind(this);
        this.handleengineModel = this.handleengineModel.bind(this);
        this.handleengineControllerModel = this.handleengineControllerModel.bind(this);
        // this.handleavrModel = this.handleavrModel.bind(this);


    }

    handlephase1Load(e) {
        //console.log(e)
        this.setState({ phase1Load: e });
    }
    handlephase2Load(e) {
        //console.log(e)
        this.setState({ phase2Load: e });
    }
    handlephase3Load(e) {
        //console.log(e)
        this.setState({ phase3Load: e });
    }
    handleloadingWithBatteryCharging(e) {
        //console.log(e)
        this.setState({ loadingWithBatteryCharging: e });
    }
    handleloadingWithoutBatteryCharging(e) {
        //console.log(e)
        this.setState({ loadingWithoutBatteryCharging: e });
    }
    handleactualFuelConsumptionRate(e) {
        //console.log(e)
        this.setState({ actualFuelConsumptionRate: e });
    }

    onChangeAvailabilityOfGenCanapy = (e) => {
        //console.log(e.target.value)
        this.setState({ availabilityOfGenCanapy: e });
    }
    handlegenCanapyStatus(e) {
        //console.log(e.target.value)
        this.setState({ genCanapyStatus: e });
    }
    handlDelayTimerStatus(e) {
        //console.log(e.target.value)
        this.setState({ delayTimerStatus: e });
    }
    handlesoundProofStatus(e) {
        //console.log(e.target.value)
        this.setState({ soundProofStatus: e });
    }
    handlegeneratorWormUpDelayTime(e) {
        //console.log(e)
        this.setState({ generatorWormUpDelayTime: e });
    }
    handlermsintegratedStatus(e) {
        //console.log(e)
        this.setState({ rmsintegratedStatus: e });
    }
    handlerMS(e) {
        //console.log(e)
        this.setState({ rms: e.target.value });
    }
    handlermsconnectionMethod(e) {
        //console.log(e)
        this.setState({ rmsconnectionMethod: e });
    }
    handlerMSRelatedSIMNumber(e) {
        //console.log(e)
        this.setState({ rmsrelatedSIMNumber: e.target.value });
    }
    handlerMsInbandOutband(e) {
        //console.log(e)
        this.setState({ rmsInbandOutband: e });
    }
    onChangeLastServicedDate = (date, dateString) => {
        this.setState({ lastServicedDate: dateString });
    }
    onChangeInstalledDate = (date, dateString) => {
        this.setState({ installedDate: dateString });
    }
    handlegeneratorControllerModel(e) {
        //console.log(e)
        this.setState({ generatorControllerModel: e });
    }
    handleengineControllerModel(e) {
        this.setState({ engineControllerModel: e });
    }
    handlehourMeterReading(e) {
        //console.log(e)
        this.setState({ hourMeterReading: e });
    }
    handlefuelTankCapacity(e) {
        //console.log(e)
        this.setState({ fuelTankCapacity: e });
    }
    handleavailableFuelQty(e) {
        //console.log(e)
        this.setState({ availableFuelQty: e });
    }
    handlAverageRunningHourspermonth(e) {
        //console.log(e)
        this.setState({ genAverageRunningHourspermonth: e });
    }

    handlegeneratorAVRModel(e) {
        this.setState({ avrModel: e });
    }

    handlegeneratorEngineModel(e) {
        //console.log(e)
        this.setState({ engineModel: e });
    }
    handlegeneratorCoolDownDelayTime(e) {
        //console.log(e)
        this.setState({ generatorCoolDownDelayTime: e });
    }
    handleengineModel(e) {
        //console.log(e)
        this.setState({ engineModel: e.target.value });
    }

    grnView(id) {
        this.getGeneratorDataView(id);
        // this.setState({ showModal1: true, });
    }
    grnUpdata(id) {
        this.getDataBulckTankBySiteId()
        this.getGeneratorData(id, 'edit');
    }
    viewMoreDetails(gen) {
        this.setState({
            showModal2: true,
            openGenDetails: true,
            selectedGenerator: gen,
        });
    }
    requestFromClose() {
        this.setState({ showModal: true, open: true });
    }
    handleGenCapacity(e) {
        //console.log(e)
        this.setState({ genCapacity: e });
    }
    handleMaxFillingLimit(e) {
        //console.log(e)
        this.setState({ genMaxFillingLimit: e });
    }
    handleAlternaterSerialNumber(e) {
        //console.log(e.target.value)
        this.setState({ alternaterSerialNumber: e.target.value });
    }
    handleMaterialCodeOfTheGenerator(e) {
        //console.log(e.target.value)
        this.setState({ materialCodeOfTheGenerator: e.target.value });
    }
    handleAnyOtherSerialNumber(e) {
        //console.log(e.target.value)
        this.setState({ anyOtherSerialNumber: e.target.value });
    }
    handleControllerSerialNumber(e) {
        //console.log(e.target.value)
        this.setState({ controllerSerialNumber: e.target.value });
    }
    handleEngineSerialNumber(e) {
        //console.log(e.target.value)
        this.setState({ engineSerialNumber: e.target.value });
    }
    handleGenSAPSerialNumber(e) {
        //console.log(e.target.value)
        this.setState({ SAPSerialNumber: e.target.value });
    }
    handleGenStatus(e) {
        //console.log(e.target.value)
        this.setState({ genStatus: e.target.value });
    }
    handleGenDescription(e) {
        //console.log(e.target.value)
        this.setState({ genDescription: e.target.value });
    }
    handleGenName(e) {
        //console.log(e.target.value)
        this.setState({ genName: e.target.value });
    }
    requestFromClose3() {
        this.setState({ showModal1: false, });
    }
    requestFromClose2() {
        this.setState({ showModal: false, });
    }
    componentDidMount() {
        this.getDataGeneratorMasterData();
        this.getDataGeneratorBySiteId();

        if (JSON.parse(localStorage.getItem('serviceTypeSet')) == null) {
            const { history } = this.props;
            history.push("/");
        } else {
            this.getSetPageData(JSON.parse(localStorage.getItem('serviceTypeSet')), 38)
        }
        checkServiceType(38).then((data) => this.setState({
            AssetManagementPermission: data
        }, () => {
        }),
        )
        this.setState({
            objectSet: {
                "genTicketNumberOfPendingFaultyTicket": this.props.details1?.access_technologies_data?.genTicketNumberOfPendingFaultyTicket,
            }
        })
        this.getDataBulckTankBySiteId();
    }

    getSetPageData = (serviceTypeIs, Pageid) => {
        if (serviceTypeIs.serviceType.filter(checkuser => checkuser?.id == Pageid)[0] != null) {
            console.log('fddf');
            this.setState({
                actionView: true,
            })
        }
    };
    getGeneratorDataView = async (id) => {
        var res = await getGeneratorDetails(id);
        if (res.success) {

            this.setState({
                Alldataview: res.data
            })


        }
    }
    getDataBulckTankBySiteId = async () => {
        var dataset = {
            'id': this.props.details.site_details.id
        }
        var res = await getBulckTankBySiteId(dataset);
        console.log("getBulckTankBySiteId");
        console.log(res);
        if (res.success) {
            this.setState({
                bulckTankList: res.data


            }, () => {
                console.log(this.state.bulckTankList)
            })
        }
    };
    getGeneratorData = async (id, modalName) => {
        var res = await getGeneratorDetails(id);
        if (res.success) {
            this.setState({
                genEdit: res?.data
            })
            this.setState({
                selectGenId: res.data?.id,
                genName: res.data?.name,
                // generatorAssetType: res.data?.asset,
                // selectedGeneratorAssetId: res.data?.asset.id,
                selectedGeneratormodelId: res.data?.model.id,
                generatorModelId: res.data?.model,
                selectedGeneratorCategory: res.data?.category.id,
                generatorCategoryType: res.data?.category,
                selectedGeneratorTypeId: res.data?.type.id,
                generatorType: res.data?.type,
                // selectedGenBulckTankId: res.data?.genBulckTank?.id,
                // GenBulckTanktype: res.data?.genBulckTank,
                genMaxFillingLimit: res.data?.maxFillingLimit,
                genCapacity: res.data?.capacity,
                genDescription: res.data?.description,
                materialCodeOfTheGenerator: res.data?.model?.materialCodeOfTheGenerator,
                SAPSerialNumber: res.data?.generatorSAPSerialNumber,
                engineSerialNumber: res.data?.engineSerialNumber,
                alternaterSerialNumber: res.data?.alternaterSerialNumber,
                controllerSerialNumber: res.data?.controllerSerialNumber,
                anyOtherSerialNumber: res.data?.anyOtherSerialNumber,

                phase1Load: res.data?.phase1Load,
                phase2Load: res.data?.phase2Load,
                phase3Load: res.data?.phase3Load,
                loadingWithBatteryCharging: res.data?.loadingWithBatteryCharging,
                loadingWithoutBatteryCharging: res.data?.loadingWithoutBatteryCharging,
                actualFuelConsumptionRate: res.data?.actualFuelConsumptionRate,
                availabilityOfGenCanapy: res.data?.availabilityOfGenCanapy,
                genCanapyStatus: res.data?.genCanapyStatus,
                soundProofStatus: res.data?.soundProofStatus,
                delayTimerStatus: res.data?.delayTimerStatus,
                generatorWormUpDelayTime: res.data?.generatorWormUpDelayTime,
                rmsintegratedStatus: res.data?.rmsintegratedStatus,
                rms: res.data?.rms,
                rmsconnectionMethod: res.data?.rmsconnectionMethod,
                rmsrelatedSIMNumber: res.data?.rmsrelatedSIMNumber,
                rmsInbandOutband: res.data?.rmsInbandOutband,

                generatorControllerModel: res.data?.generatorControllerModel,
                availableFuelQty: res.data?.availableFuelQty,
                fuelTankCapacity: res.data?.fuelTankCapacity,
                hourMeterReading: res.data?.hourMeterReading,
                generatorCoolDownDelayTime: res.data?.generatorCoolDownDelayTime,
                engineModel: res.data?.engineModel,
                genAverageRunningHourspermonth: res.data?.averageRunningHoursPerMonth,
                // engineModel: res.data?.engineModel,
                engineControllerModel: res.data?.engineControllerModel,
                avrModel: res.data?.avrModel



            })
            if (res.data?.genBulckTank != null) {
                this.setState({
                    selectedGenBulckTankId: res.data?.genBulckTank?.id,
                    GenBulckTanktype: res.data?.genBulckTank,
                })

            } else {
                this.setState({
                    selectedGenBulckTankId: null,
                    GenBulckTanktype: [],
                })
            }
            if (res.data?.make != null) {
                this.setState({
                    selectedGeneratorMakeId: res.data?.make?.id,
                    generatorMakeId: res.data?.make,
                })

            } else {
                this.setState({
                    selectedGeneratorMakeId: null,
                    generatorMakeId: [],
                })
            }
            if (res.data?.active == false) {
                this.setState({
                    generatorIsActive: 0
                })

            } else {
                this.setState({
                    generatorIsActive: 1
                })
            }
            if (res.data?.lastServicedDate != null) {
                //  //console.log("on Air fuck")
                this.setState({
                    lastServicedDate: res.data?.lastServicedDate
                })
            } else {
                this.setState({
                    lastServicedDate: '',
                })
            }

            if (res.data?.installedDate != null) {
                //  //console.log("on Air fuck")
                this.setState({
                    installedDate: res.data?.installedDate
                })
            } else {
                this.setState({
                    installedDate: '',
                })
            }
            if (res.data?.warrantyExpiredDate != null) {
                //  //console.log("on Air fuck")
                this.setState({
                    WarrantyExpiredDate: res.data?.warrantyExpiredDate
                })
            } else {
                this.setState({
                    WarrantyExpiredDate: '',
                })
            }
        }

        if (modalName === 'edit') {
            this.setState({ 
                showModal1: true, 
                openEdit: true,
                isUpadetQuery: true
            });
        } else {

        }


    }
    getDataGeneratorBySiteId = async () => {
        var dataset = {
            'id': this.props.details.site_details.id
        }
        var res = await getGeneratorBySiteId(dataset);

        if (res.success) {
            this.setState({
                siteGeneratorList: res.data


            })
        }
    };

    getDataGeneratorMasterData = async () => {
        var res = await getGeneratorMasterData();
        console.log("getGeneratorMasterData");
        console.log(res.data);
        if (res.success) {
            this.setState({
                assetsList: res.data.assets,
                modelList: res.data.models,
                categoriesList: res.data.categories,
                tankTypesList: res.data.tankTypes,


            })
        }
    };
    onChangeWarrantyExpiredDate = (date, dateString) => {
        //console.log(date);
        //console.log(dateString);
        this.setState({
            WarrantyExpiredDate: dateString,
        });
    };
    onChangeGenBulckTank = (value) => {
        //console.log("onChangeGenBulckTank");
        //console.log(value);
        this.setState({
            selectedGenBulckTankId: value,
            GenBulckTanktype: {
                "id": value
            },

        })
    };
    onChangeGeneratorType = (value) => {
        this.getDataBulckTankBySiteId();
        //console.log("onChangeGeneratorType");
        //console.log(value);
        //console.log('dddddddd1')

        if (value == 1) {
            //console.log('dddddddd2')
            this.setState({
                selectedGenBulckTankId: null,
                GenBulckTanktype: [],
            })
        }
        this.setState({
            selectedGeneratorTypeId: value,
            generatorType: {
                "id": value
            },

        })
    };
    onChangeGeneratorCategory = (value) => {
        //console.log("onChangeGeneratorCategory");
        //console.log(value);
        this.setState({
            selectedGeneratorCategory: value,
            generatorCategoryType: {
                "id": value
            },

        })
    };
    onChangeGeneratorMake = (value) => {
        //console.log("onChangeGeneratormodel");
        //console.log(value);
        this.setState({
            selectedGeneratorMakeId: value,
            generatorMakeId: {
                "id": value
            },

        })
    };
    onChangeGeneratormodel = (value) => {
        //console.log("onChangeGeneratormodel");
        //console.log(value);
        this.setState({
            selectedGeneratormodelId: value,
            generatorModelId: {
                "id": value
            },

        })
    };
    onChangeGeneratorAsset = (value) => {
        //console.log("onChangeGeneratorAsset");
        //console.log(value);
        this.setState({
            selectedGeneratorAssetId: value,
            generatorAssetType: {
                "id": value
            },

        })
    };
    onChangeGeneratorIsActive = (value) => {
        //console.log("onChangeGeneratorIsActive");
        //console.log(value);
        this.setState({
            generatorIsActive: parseInt(value),


        })
    };
    AllDataSubmitToUpdate = async () => {
        if (this.state.selectedGenBulckTankId != null) {

            if (this.validator.allValid()) {
                var dataSet;
                dataSet = {
                    "id": this.state.selectGenId,
                    "name": this.state.genName,
                    "description": this.state.genDescription,
                    "active": this.state.generatorIsActive,
                    "status": this.state.genStatus,
                    "maxFillingLimit": this.state.genMaxFillingLimit,
                    "capacity": this.state.genCapacity,
                    "warrantyExpiredDate": this.state.WarrantyExpiredDate,
                    "generatorSAPSerialNumber": this.state.SAPSerialNumber,
                    "engineSerialNumber": this.state.engineSerialNumber,
                    "alternaterSerialNumber": this.state.alternaterSerialNumber,
                    "controllerSerialNumber": this.state.controllerSerialNumber,
                    // "anyOtherSerialNumber": this.state.anyOtherSerialNumber,
                    // "materialCodeOfTheGenerator": this.state.materialCodeOfTheGenerator,
                    "site": { "id": this.props.details.site_details.id },
                    "model": this.state.generatorModelId,
                    "make": this.state.generatorMakeId,
                    "type": this.state.generatorType,
                    "category": this.state.generatorCategoryType,
                    "asset": {
                        "id": 2
                    },
                    "genBulckTank": this.state.GenBulckTanktype,

                    "phase1Load": this.state.phase1Load,
                    "phase2Load": this.state.phase2Load,
                    "phase3Load": this.state.phase3Load,
                    "loadingWithBatteryCharging": this.state.loadingWithBatteryCharging,
                    "loadingWithoutBatteryCharging": this.state.loadingWithoutBatteryCharging,
                    "actualFuelConsumptionRate": this.state.actualFuelConsumptionRate,
                    "availabilityOfGenCanapy": this.state.availabilityOfGenCanapy,
                    "genCanapyStatus": this.state.genCanapyStatus,
                    "soundProofStatus": this.state.soundProofStatus,
                    "delayTimerStatus": this.state.delayTimerStatus,
                    "generatorWormUpDelayTime": this.state.generatorWormUpDelayTime,
                    "rmsintegratedStatus": this.state.rmsintegratedStatus,
                    "rms": this.state.rms,
                    "rmsconnectionMethod": this.state.rmsconnectionMethod,
                    "rmsrelatedSIMNumber": this.state.rmsrelatedSIMNumber,
                    "rmsInbandOutband": this.state.rmsInbandOutband,
                    "installedDate": this.state.installedDate,
                    "lastServicedDate": this.state.lastServicedDate,
                    "generatorControllerModel": this.state.generatorControllerModel,
                    "availableFuelQty": this.state.availableFuelQty,
                    "fuelTankCapacity": this.state.fuelTankCapacity,
                    "hourMeterReading": this.state.hourMeterReading,
                    "generatorCoolDownDelayTime": this.state.generatorCoolDownDelayTime,
                    "engineModel": this.state.engineModel,
                    "averageRunningHoursPerMonth": this.state.genAverageRunningHourspermonth,
                    // "engineModel":this.state.engineModel,
                    "engineControllerModel": this.state.engineControllerModel,
                    "avrModel": this.state.avrModel

                }
                //console.log(dataSet)
                var res = await Updategenerator(dataSet);
                if (res.success) {
                    message.success('Successfully Generator Edited!')
                    this.formRef.current.resetFields();
                    this.getDataGeneratorBySiteId();
                    this.props.parentMethod();
                    this.setState({
                        showModal1: false,
                        openEdit: false,
                        isUpadetQuery: false
                    })
                } else {
                    message.warning(' Something went wrong!')
                }
            } else {
                this.validator.showMessages();
                this.forceUpdate();
            }
        } else {
            if (this.validator.allValid()) {
                var dataSet;
                dataSet = {
                    "id": this.state.selectGenId,
                    "name": this.state.genName,
                    "description": this.state.genDescription,
                    "active": this.state.generatorIsActive,
                    "status": this.state.genStatus,
                    "maxFillingLimit": this.state.genMaxFillingLimit,
                    "capacity": this.state.genCapacity,
                    "warrantyExpiredDate": this.state.WarrantyExpiredDate,
                    "generatorSAPSerialNumber": this.state.SAPSerialNumber,
                    "engineSerialNumber": this.state.engineSerialNumber,
                    "alternaterSerialNumber": this.state.alternaterSerialNumber,
                    "controllerSerialNumber": this.state.controllerSerialNumber,
                    // "anyOtherSerialNumber": this.state.anyOtherSerialNumber,
                    //   "materialCodeOfTheGenerator": this.state.materialCodeOfTheGenerator,
                    "site": { "id": this.props.details.site_details.id },
                    "model": this.state.generatorModelId,
                    "make": this.state.generatorMakeId,
                    "type": this.state.generatorType,
                    "category": this.state.generatorCategoryType,
                    "asset": {
                        "id": 2
                    },
                    // "genBulckTank": this.state.GenBulckTanktype

                    "phase1Load": this.state.phase1Load,
                    "phase2Load": this.state.phase2Load,
                    "phase3Load": this.state.phase3Load,
                    "loadingWithBatteryCharging": this.state.loadingWithBatteryCharging,
                    "loadingWithoutBatteryCharging": this.state.loadingWithoutBatteryCharging,
                    "actualFuelConsumptionRate": this.state.actualFuelConsumptionRate,
                    "availabilityOfGenCanapy": this.state.availabilityOfGenCanapy,
                    "genCanapyStatus": this.state.genCanapyStatus,
                    "soundProofStatus": this.state.soundProofStatus,
                    "delayTimerStatus": this.state.delayTimerStatus,
                    "generatorWormUpDelayTime": this.state.generatorWormUpDelayTime,
                    "rmsintegratedStatus": this.state.rmsintegratedStatus,
                    "rms": this.state.rms,
                    "rmsconnectionMethod": this.state.rmsconnectionMethod,
                    "rmsrelatedSIMNumber": this.state.rmsrelatedSIMNumber,
                    "rmsInbandOutband": this.state.rmsInbandOutband,
                    "installedDate": this.state.installedDate,
                    "lastServicedDate": this.state.lastServicedDate,

                    "generatorControllerModel": this.state.generatorControllerModel,
                    "availableFuelQty": this.state.availableFuelQty,
                    "fuelTankCapacity": this.state.fuelTankCapacity,
                    "hourMeterReading": this.state.hourMeterReading,

                    "generatorCoolDownDelayTime": this.state.generatorCoolDownDelayTime,
                    "engineModel": this.state.engineModel,

                    "averageRunningHoursPerMonth": this.state.genAverageRunningHourspermonth,
                    // "engineModel":this.state.engineModel,
                    "engineControllerModel": this.state.engineControllerModel,
                    "avrModel": this.state.avrModel

                }
                //console.log(dataSet)
                var res = await Updategenerator(dataSet);
                if (res.success) {
                    message.success('Successfully Generator Edited!')
                    this.formRef.current.resetFields();
                    this.getDataGeneratorBySiteId();
                    this.props.parentMethod();

                    this.setState({
                        showModal1: false,
                        openEdit: false,
                        isUpadetQuery: false
                    })
                    // const { history } = this.props;
                    // history.push("/site");
                } else {
                    message.warning(' Something went wrong!')
                }

            } else {
                this.validator.showMessages();
                // rerender to show messages for the first time
                // you can use the autoForceUpdate option to do this automatically`
                this.forceUpdate();
            }

        }

    }
    AllDataSubmit = async () => {
        if (this.state.selectedGenBulckTankId != null) {
            if (this.validator.allValid()) {
                var dataSet;
                dataSet = {

                    "name": this.state.genName,
                    "description": this.state.genDescription,
                    "active": this.state.generatorIsActive,
                    "status": this.state.genStatus,
                    "maxFillingLimit": this.state.genMaxFillingLimit,
                    "capacity": this.state.genCapacity,
                    "warrantyExpiredDate": this.state.WarrantyExpiredDate,
                    "generatorSAPSerialNumber": this.state.SAPSerialNumber,
                    "engineSerialNumber": this.state.engineSerialNumber,
                    "alternaterSerialNumber": this.state.alternaterSerialNumber,
                    "controllerSerialNumber": this.state.controllerSerialNumber,
                    // "anyOtherSerialNumber": this.state.anyOtherSerialNumber,
                    //"materialCodeOfTheGenerator": this.state.materialCodeOfTheGenerator,
                    "site": { "id": this.props.details.site_details.id },
                    "model": this.state.generatorModelId,
                    "make": this.state.generatorMakeId,
                    "type": this.state.generatorType,
                    "category": this.state.generatorCategoryType,
                    "asset": {
                        "id": 2
                    },
                    "genBulckTank": this.state.GenBulckTanktype,

                    "phase1Load": this.state.phase1Load,
                    "phase2Load": this.state.phase2Load,
                    "phase3Load": this.state.phase3Load,
                    "loadingWithBatteryCharging": this.state.loadingWithBatteryCharging,
                    "loadingWithoutBatteryCharging": this.state.loadingWithoutBatteryCharging,
                    "actualFuelConsumptionRate": this.state.actualFuelConsumptionRate,
                    "availabilityOfGenCanapy": this.state.availabilityOfGenCanapy,
                    "genCanapyStatus": this.state.genCanapyStatus,
                    "soundProofStatus": this.state.soundProofStatus,
                    "delayTimerStatus": this.state.delayTimerStatus,
                    "generatorWormUpDelayTime": this.state.generatorWormUpDelayTime,
                    "rmsintegratedStatus": this.state.rmsintegratedStatus,
                    "rms": this.state.rms,
                    "rmsconnectionMethod": this.state.rmsconnectionMethod,
                    "rmsrelatedSIMNumber": this.state.rmsrelatedSIMNumber,
                    "rmsInbandOutband": this.state.rmsInbandOutband,
                    "installedDate": this.state.installedDate,
                    "lastServicedDate": this.state.lastServicedDate,
                    "generatorControllerModel": this.state.generatorControllerModel,
                    "availableFuelQty": this.state.availableFuelQty,
                    "fuelTankCapacity": this.state.fuelTankCapacity,
                    "hourMeterReading": this.state.hourMeterReading,
                    "generatorCoolDownDelayTime": this.state.generatorCoolDownDelayTime,
                    "engineModel": this.state.engineModel,
                    "averageRunningHoursPerMonth": this.state.genAverageRunningHourspermonth,
                    "engineControllerModel": this.state.engineControllerModel,
                    "avrModel": this.state.avrModel
                }
                var res = await Creategenerator(dataSet);
                if (res.success) {
                    message.success('Successfully Generator Added!')
                    this.formRef.current.resetFields();
                    this.getDataGeneratorBySiteId();
                    this.setState({
                        showModal: false,
                        open: false,
                        openEdit: false, 
                        genEdit : false, 
                        isUpadetQuery: false
                    })
                    this.props.parentMethod();
                } else {
                    message.warning(' Something went wrong!')
                }
            } else {
                this.validator.showMessages();
                this.forceUpdate();
            }
        } else {
            if (this.validator.allValid()) {
                var dataSet;
                dataSet = {

                    "name": this.state.genName,
                    "description": this.state.genDescription,
                    "active": this.state.generatorIsActive,
                    "status": this.state.genStatus,
                    "maxFillingLimit": this.state.genMaxFillingLimit,
                    "capacity": this.state.genCapacity,
                    "warrantyExpiredDate": this.state.WarrantyExpiredDate,
                    "generatorSAPSerialNumber": this.state.SAPSerialNumber,
                    "engineSerialNumber": this.state.engineSerialNumber,
                    "alternaterSerialNumber": this.state.alternaterSerialNumber,
                    "controllerSerialNumber": this.state.controllerSerialNumber,
                    // "anyOtherSerialNumber": this.state.anyOtherSerialNumber,
                    // "materialCodeOfTheGenerator": this.state.materialCodeOfTheGenerator,
                    "site": { "id": this.props.details.site_details.id },
                    "model": this.state.generatorModelId,
                    "make": this.state.generatorMakeId,
                    "type": this.state.generatorType,
                    "category": this.state.generatorCategoryType,
                    "asset": {
                        "id": 2
                    },
                    //"genBulckTank": this.state.GenBulckTanktype

                    "phase1Load": this.state.phase1Load,
                    "phase2Load": this.state.phase2Load,
                    "phase3Load": this.state.phase3Load,
                    "loadingWithBatteryCharging": this.state.loadingWithBatteryCharging,
                    "loadingWithoutBatteryCharging": this.state.loadingWithoutBatteryCharging,
                    "actualFuelConsumptionRate": this.state.actualFuelConsumptionRate,
                    "availabilityOfGenCanapy": this.state.availabilityOfGenCanapy,
                    "genCanapyStatus": this.state.genCanapyStatus,
                    "soundProofStatus": this.state.soundProofStatus,
                    "delayTimerStatus": this.state.delayTimerStatus,
                    "generatorWormUpDelayTime": this.state.generatorWormUpDelayTime,
                    "rmsintegratedStatus": this.state.rmsintegratedStatus,
                    "rms": this.state.rms,
                    "rmsconnectionMethod": this.state.rmsconnectionMethod,
                    "rmsrelatedSIMNumber": this.state.rmsrelatedSIMNumber,
                    "rmsInbandOutband": this.state.rmsInbandOutband,
                    "installedDate": this.state.installedDate,
                    "lastServicedDate": this.state.lastServicedDate,

                    "generatorControllerModel": this.state.generatorControllerModel,
                    "availableFuelQty": this.state.availableFuelQty,
                    "fuelTankCapacity": this.state.fuelTankCapacity,
                    "hourMeterReading": this.state.hourMeterReading,

                    "generatorCoolDownDelayTime": this.state.generatorCoolDownDelayTime,
                    "engineModel": this.state.engineModel,

                    "averageRunningHoursPerMonth": this.state.genAverageRunningHourspermonth,
                    // "engineModel":this.state.engineModel,
                    "engineControllerModel": this.state.engineControllerModel,
                    "avrModel": this.state.avrModel

                }
                console.log(dataSet)
                var res = await Creategenerator(dataSet);
                if (res.success) {
                    message.success('Successfully Generator Added!');
                    this.formRef.current.resetFields();
                    this.getDataGeneratorBySiteId();
                    this.props.parentMethod();

                    this.setState({
                        showModal: false,
                        open: false,
                        isUpadetQuery: false
                    })
                    // const { history } = this.props;
                    // history.push("/site");
                } else {
                    message.warning(' Something went wrong!')
                }

            } else {
                this.validator.showMessages();
                //console.log( this.validator)
                // rerender to show messages for the first time
                // you can use the autoForceUpdate option to do this automatically`
                this.forceUpdate();
            }

        }

    }
    onDrawerCloseEdit = () => {
        this.formRef.current.resetFields();
        this.validator.hideMessages();
        this.setState({
            openEdit: false,
            selectGenId: '',
            genName: '',
            generatorAssetType: [],
            selectedGeneratorAssetId: null,
            selectedGeneratormodelId: null,
            generatorModelId: [],
            selectedGeneratorMakeId: null,
            generatorMakeId: [],
            selectedGeneratorCategory: null,
            generatorCategoryType: [],
            selectedGeneratorTypeId: null,
            generatorType: '',
            selectedGenBulckTankId: null,
            GenBulckTanktype: [],
            genMaxFillingLimit: '',
            genCapacity: '',
            genDescription: '',
            materialCodeOfTheGenerator: '',
            SAPSerialNumber: '',
            engineSerialNumber: '',
            alternaterSerialNumber: '',
            controllerSerialNumber: '',
            anyOtherSerialNumber: '',
            WarrantyExpiredDate: null,

            phase1Load: '',
            phase2Load: '',
            phase3Load: '',
            loadingWithBatteryCharging: '',
            loadingWithoutBatteryCharging: '',
            actualFuelConsumptionRate: '',
            availabilityOfGenCanapy: null,
            genCanapyStatus: '',
            soundProofStatus: '',
            delayTimerStatus: '',
            generatorWormUpDelayTime: '',
            rmsintegratedStatus: '',
            rms: '',
            rmsconnectionMethod: '',
            rmsrelatedSIMNumber: '',
            rmsInbandOutband: '',
            installedDate: '',
            lastServicedDate: "",

            generatorControllerModel: '',
            availableFuelQty: '',
            fuelTankCapacity: '',
            hourMeterReading: '',

            generatorCoolDownDelayTime: '',


            engineModel: '',
            engineControllerModel: '',
            avrModel: '',
            isUpadetQuery: false
        })
    }
    onDrawerClose = () => {
        console.log('sddsds')
        this.formRef.current.resetFields();
        this.validator.hideMessages();
        this.setState({
            open: false,
            isUpadetQuery: false,
        })

    }
    onViewMoreDetailsDrawerClose = () => {
        this.setState({
            showModal2: false,
            openGenDetails: false,

        })

    }
    getDataDetailsForDelete = async (id) => {
        var res = await getGeneratorDetails(id);
        console.log(res);
        if (res.success) {
            var respons = AssetDelete.Action(res.data, this.props.details.site_details.id, Updategenerator)



            respons.then((value) => {
                if (value == 1) {
                    message.success('Successfully Delete!')
                    this.props.parentMethod();
                } else {
                    message.warning(' Something went wrong!')
                }


            });



        }

    }
    submitForm = async (item) => {
        this.getDataDetailsForDelete(item);

    }

    validatedTextLable = (field) => {
        return (field !== null && field !== '')
            ? <span class="badge badge-outline-secondary text-muted">{(field)}</span>
            : <span class="badge text-danger">Currently Not Set</span>;
    }

    validatedBoolLable = (field) => {
        return (field !== null && field !== '')
            ? field == true
                ? <span class="badge badge-outline-success badge-pill"> Yes </span>
                : <span class="badge badge-outline-pink badge-pill"> No </span>
            : <span class="badge text-danger">Currently Not Set</span>;
    }
    handlgenTicketNumberOfPendingFaultyTicket = (e) => {
        this.setState({
            objectSet: {
                ...this.state.objectSet,
                genTicketNumberOfPendingFaultyTicket: e
            }

        }, () => {
            console.log(this.state.objectSet)
        })

    }
    dataUpdate() {
        console.log("ssss")
        this.setState({
            switchStatus: false
        })
    }
    close = async () => {
        this.props.parentMethod();
        this.setState({
            objectSet: {
                "genTicketNumberOfPendingFaultyTicket": this.props.details1?.access_technologies_data?.genTicketNumberOfPendingFaultyTicket,


            }
        });
        this.setState({
            switchStatus: true
        });
    }
    dataSetToUpdate = async () => {

        console.log(this.state.objectSet)
        console.log(this.props.detailsupdateGeneralDetails.updateGeneralDetails)
        let remoteJob = {
            ...this.props.detailsupdateGeneralDetails.updateGeneralDetails,
            ...this.state.objectSet
        };
        const formData = new FormData();
        formData.append('id', this.props.details1?.access_technologies_data?.id);
        formData.append('object', JSON.stringify(remoteJob));

        var res = await dataUpdateGeneralDetails(formData);

        if (res.success) {
            message.success('Successfully Update!')
            this.props.parentMethod();
            this.setState({
                switchStatus: true
            })
        } else {
            message.warning(' Something went wrong!')
        }


    }

    render() {
        const { Option } = Select;
        const { Panel } = Collapse;
        const generator = this.state.selectedGenerator;
        console.log("generator_klll")
        console.log(generator)

        const columns2 = [
            {
                title: "Name",
                details: [],
                dataIndex: "name",
                content: <Tag color="blue" style={{ margin: "0px" }}><span>{generator.name}</span></Tag>
            },
            {
                title: "Make",
                details: [],
                dataIndex: "make",
                content: generator !== ""
                    ? <span class="badge bg-secondary">{generator.make?.name}</span>
                    : <></>
            },
            {
                title: "Model",
                details: [
                    {
                        title: "Material Code Of The Generator",
                        details: [],
                        dataIndex: "materialCodeOfTheGenerator",
                        content: this.validatedTextLable(generator.model?.materialCodeOfTheGenerator),
                    },
                ],
                dataIndex: "model",
                content: generator !== "" ? <span class="badge badge-outline-info badge-pill"><i class="fas fa-hdd" style={{ paddingRight: "5px" }} />{(generator.model?.name)}</span> : <></>,
            },
            {
                title: "Capacity(kVA)",
                details: [],
                dataIndex: "capacity",
                content: this.validatedTextLable(generator.capacity),
            },
            {
                title: "Generator SAP Serial Number",
                details: [],
                dataIndex: "generatorSAPSerialNumber",
                content: this.validatedTextLable(generator.generatorSAPSerialNumber)
            },
            {
                title: "Engine Serial Number",
                details: [],
                dataIndex: "engineSerialNumber",
                content: this.validatedTextLable(generator.engineSerialNumber),
            },
            {
                title: "Alternater Serial Number",
                details: [],
                dataIndex: "alternaterSerialNumber",
                content: this.validatedTextLable(generator.alternaterSerialNumber),
            },
            {
                title: "Controller Serial Number",
                details: [],
                dataIndex: "controllerSerialNumber",
                content: this.validatedTextLable(generator.controllerSerialNumber),
            },
            {
                title: "Engine Model",
                details: [],
                dataIndex: "engineModel",
                content: this.validatedTextLable(generator.engineModel),

            },
            // {
            //     title: "Generator Controller Model",
            //     details: [],
            //     dataIndex: "generatorControllerModel",
            //     content: this.validatedTextLable(generator.generatorControllerModel),
            // },
            {
                title: "Engine Controller Model",
                details: [],
                dataIndex: "engineControllerModel",
                content: this.validatedTextLable(generator.engineControllerModel),
            },
            {
                title: "AVR Model ",
                details: [],
                dataIndex: "avrModel",
                content: generator !== ""
                    ? <span class="badge bg-secondary">{generator?.avrModel}</span>
                    : <></>
            },
            {
                title: "Fuel Tank Capacity(l)",
                details: [],
                dataIndex: "fuelTankCapacity",
                content: this.validatedTextLable(generator.fuelTankCapacity),
            },
            {
                title: "Bulk Tank Capacity (l)",
                details: [],
                dataIndex: "genBulckTank",
                content: this.validatedTextLable(generator?.genBulckTank != null ? (generator?.genBulckTank?.capacity) : ('')),
            },
            {
                title: "Average Running Hours Per Month",
                details: [],
                dataIndex: "averageRunningHoursPerMonth",
                content: this.validatedTextLable(generator.averageRunningHoursPerMonth),
            },
            {
                title: "Phase1 Load (A)",
                details: [],
                dataIndex: "phase1Load",
                content: this.validatedTextLable(generator.phase1Load),
            },
            {
                title: "Phase2 Load (A)",
                details: [],
                dataIndex: "phase2Load",
                content: this.validatedTextLable(generator.phase2Load),
            },
            {
                title: "Phase3 Load (A)",
                details: [],
                dataIndex: "phase3Load",
                content: this.validatedTextLable(generator.phase3Load),
            },
            {
                title: "Hour Meter Reading (Hrs)",
                details: [],
                dataIndex: "hourMeterReading",
                content: this.validatedTextLable(generator.hourMeterReading),
            },
            {
                title: "Loading With Battery Charging(%)",
                details: [],
                dataIndex: "loadingWithBatteryCharging",
                content: this.validatedTextLable(generator.loadingWithBatteryCharging),
            },
            {
                title: "Loading Without Battery Charging(%)",
                details: [],
                dataIndex: "loadingWithoutBatteryCharging",
                content: this.validatedTextLable(generator.loadingWithoutBatteryCharging),
            },
            {
                title: "Available Fuel Qty (l)",
                details: [],
                dataIndex: "availableFuelQty",
                content: this.validatedTextLable(generator.availableFuelQty),
            },

            {
                title: "Actual Fuel Consumption Rate (Litres/Hour)",
                details: [],
                dataIndex: "actualFuelConsumptionRate",
                content: this.validatedTextLable(generator.actualFuelConsumptionRate),
            },

            {
                title: "Availability Of Gen Canapy",
                details: [],
                dataIndex: "availabilityOfGenCanapy",
                content: this.validatedBoolLable(generator.availabilityOfGenCanapy),
            },
            {
                title: "Gen Canapy Status",
                details: [],
                dataIndex: "genCanapyStatus",
                content: this.validatedTextLable(generator.genCanapyStatus),
            },
            {
                title: "Sound Proof Status",
                details: [],
                dataIndex: "soundProofStatus",
                content: this.validatedTextLable(generator.soundProofStatus),
            },

            {
                title: "Delay Timer Status",
                details: [],
                dataIndex: "delayTimerStatus",
                content: this.validatedTextLable(generator.delayTimerStatus),
            },
            {
                title: "Generator start up delay time (min)",
                details: [],
                dataIndex: "generatorWormUpDelayTime",
                content: this.validatedTextLable(generator.generatorWormUpDelayTime),
            },
            {
                title: "Generator cool down delay time (min)",
                details: [],
                dataIndex: "generatorCoolDownDelayTime",
                content: this.validatedTextLable(generator.generatorCoolDownDelayTime),
            },
            {
                title: "RMS Integrated Status",
                details: [],
                dataIndex: "rmsintegratedStatus",
                content: this.validatedTextLable(generator.rmsintegratedStatus),
            },
            {
                title: "RMS Inband/Outband",
                details: [],
                dataIndex: "rmsInbandOutband",
                content: this.validatedTextLable(generator.rmsInbandOutband),

            },
            {
                title: "RMS Connection Method",
                details: [],
                dataIndex: "rmsconnectionMethod",
                content: this.validatedTextLable(generator.rmsconnectionMethod),
            },

            {
                title: "RMS Related SIM Number",
                details: [],
                dataIndex: "rmsrelatedSIMNumber",
                content: this.validatedTextLable(generator.rmsrelatedSIMNumber),

            },
            {
                title: "Last Serviced Date",
                details: [],
                dataIndex: "lastServicedDate",
                content: this.validatedTextLable(generator.lastServicedDate),
            },
            {
                title: "Installed Date",
                details: [],
                dataIndex: "installedDate",
                content: this.validatedTextLable(generator.installedDate),
            },
            // -------------------------------------------------------------------------------------------------------
            {
                title: "Active",
                details: [],
                dataIndex: "active",
                content: generator.active
                    ? <span class="badge bg-success">true</span>
                    : <span class="badge bg-danger">false</span>,
            },
            {
                title: "Type",
                details: [],
                dataIndex: "type",
                content: generator !== ""
                    ? <span class="badge bg-secondary">{generator.type?.name}</span>
                    : <></>
            },
            {
                title: "Category",
                details: [],
                dataIndex: "category",
                content: generator !== "" ? <span class="badge badge-soft-warning fw-semibold">{generator.category?.name}</span> : <></>,
            },
            {
                title: "Description",
                details: [],
                dataIndex: "description",
                content: this.validatedTextLable(generator.description),
            },
            // {
            //     title: "Any Other Serial Number",
            //     details: [],
            //     dataIndex: "anyOtherSerialNumber",
            //     content: this.validatedTextLable(generator.anyOtherSerialNumber),
            // },
            {
                title: "Fuel Half Filling",
                details: [],
                dataIndex: "fuelHalfFilling",
                content: this.validatedBoolLable(generator.fuelHalfFilling)
            },
            {
                title: "Last Filling Quantity",
                details: [],
                dataIndex: "lastFillingQuantity",
                content: this.validatedTextLable(generator.lastFillingQuantity),
            },
            {
                title: "Last Gen Efficiency",
                details: [],
                dataIndex: "lastGenEfficiency",
                content: this.validatedTextLable(generator.lastGenEfficiency),
            },
            {
                title: "Last Meter Reading",
                details: [],
                dataIndex: "lastMeterReading",
                content: this.validatedTextLable(generator.lastMeterReading),
            },
            {
                title: "Last Remaining Fuel Quantity",
                details: [],
                dataIndex: "lastRemainingFuelQuantity",
                content: this.validatedTextLable(generator.lastRemainingFuelQuantity),
            },
            {
                title: "Last Runing Hours",
                details: [],
                dataIndex: "lastRuningHours",
                content: this.validatedTextLable(generator.lastRuningHours),
            },
            {
                title: "Max Filling Limit",
                details: [],
                dataIndex: "maxFillingLimit",
                content: this.validatedTextLable(generator.maxFillingLimit),
            },
            {
                title: "Warranty Expired Date",
                details: [],
                dataIndex: "warrantyExpiredDate",
                content: this.validatedTextLable(generator.warrantyExpiredDate),
            },
        ];

        return (
            <div className="row">
                <div style={{ width: "100%", backgroundColor: "white", padding: "20px", borderRadius: "5px" }}>
                    <div className="d-flex justify-content-end align-items-center" style={{ marginBottom: "10px", marginRight: "10px" }}>
                        {this.state.switchStatus
                            ?
                            checkPermissions('SITE_VIEW_GENERAL_USER') || checkPermissions('SITE_VIEW_ADMIN_USER') ? (
                            <Fragment>
                                <button type="button"
                                    style={{ borderRadius: 5, backgroundColor: '#F28502', borderColor: '#F28502' }}
                                    class="btn btn-soft-primary btn-icon-square-sm"
                                    onClick={() => this.dataUpdate()}> <i class="mdi mdi-pencil-outline" style={{ color: 'white' }}></i></button>
                                {this.state.actionView
                                    ?
                                    <Button
                                        type="button"
                                        class="btn btn-soft-primary btn-sm"
                                        style={{ borderColor: '#BA183A', backgroundColor: '#BA183A', borderRadius: '5px', marginLeft: '10px' }}
                                        onClick={() => this.setState({ openEdit: true, genEdit: false })}
                                        icon={<PlusCircleOutlined style={{ color: 'white' }} />}>
                                        <span className="textStyles-small" style={{ color: 'white' }}>New Asset</span>
                                    </Button>
                                    : ('')
                                }
                            </Fragment>): ('')
                            : <div class="d-flex justify-content-end align-items-center">
                                <button type="button" class="btn btn-soft-secondary  textStyles-small" onClick={() => this.close()} style={{ marginRight: "10px" }}> Cancel </button>
                                <button type="button" class="btn btn-soft-primary  textStyles-small" onClick={() => this.dataSetToUpdate()}> Submit to Update </button>
                            </div>
                        }
                    </div>
                    <ul class="list-group">
                        <Row span={24}>
                            <Col span={12}>
                                <div style={{ width: '98%' }}>

                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <div>
                                            <span className="textStyles-small">No. of Generators</span>
                                        </div>
                                        {this.props.details1?.access_technologies_data?.noOfGenerators != null ?
                                            (<span class="badge badge-outline-success textStyles-small">{this.props.details2?.generators_data.length}</span>) :
                                            (<span class="badge badge-outline-warning textStyles-small">Currently Not Set</span>)}
                                    </li>
                                </div>
                            </Col>

                            <Col span={12}>
                                <div style={{ width: '98%' }}>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <div>
                                            <span className="textStyles-small">Ticket numbers of pending Tickets</span>
                                        </div>
                                        {this.state.switchStatus ? (<>{this.props.details1?.access_technologies_data?.genTicketNumberOfPendingFaultyTicket != null ? (
                                            <span class="badge badge-outline-success textStyles-small">{this.props.details1?.access_technologies_data?.genTicketNumberOfPendingFaultyTicket}</span>) : (
                                            <span class="badge badge-outline-warning textStyles-small">Currently Not Set</span>)}</>) : (<>
                                                <InputNumber min={0}
                                                    style={{ width: '120px', height: 34 }}
                                                    className='borderedSelect'
                                                    value={this.state.objectSet?.genTicketNumberOfPendingFaultyTicket} id="cnoOfCabinetsWithEquipmentInstalled"
                                                    onChange={this.handlgenTicketNumberOfPendingFaultyTicket} /> </>)}
                                    </li>
                                </div>
                            </Col>
                        </Row>
                    </ul>
                </div>

                <Row span={24} style={{ marginTop: 30 }}>
                    {this.props.details2?.generators_data?.map((generator, index) => (
                        <Col span={8} key={index}>
                        <Card
                          bordered={false}
                          style={{
                            width: '98%',
                            borderRadius: '10px',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                            position: 'relative',
                            marginTop: 10
                          }}
                        >
                          <div style={{ display: 'flex', marginBottom: 16, backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '10px' }}>
                            <div>
                              <HomeOutlined style={{ marginLeft: '3px', marginRight: '3px' }} /> &rarr;
                              <span style={{ marginLeft: '3px', marginRight: '3px', fontWeight: 'bold' }} className="textStyles-small">
                              {this.props.details?.site_details?.siteName?.slice(0, 15)}
                              </span>
                              &rarr;
                              <span style={{ marginLeft: '3px', color: '#BA183A', fontWeight: 'bold' }} className="textStyles-small">{generator?.name?.slice(0, 15)}</span>
                            </div>
                          </div>
                          <div style={{ marginBottom: 8 }}>
                            <span className="textStyles-small" style={{ fontSize: 12 }}>Type</span>
                            <Tag color="default" style={{ float: 'right', borderRadius: 5 }}> <span className="textStyles-small">{generator?.type?.name}</span></Tag>
                          </div>
                          <div style={{ marginBottom: 8 }}>
                            <span className="textStyles-small">Model</span>
                            <Tag color="purple" style={{ float: 'right', borderRadius: 5 }} tooltip="This is a required field">
                              <span className="textStyles-small" style={{ fontSize: 11 }}>
                                {generator?.model?.name}
                              </span></Tag>
                          </div>
                          <div style={{ marginBottom: 8 }}>
                            <span className="textStyles-small">Active Status</span>
                              {
                                generator.active ? <Tag color="green" style={{ float: 'right', borderRadius: 5 }} >
                                <span className="textStyles-small" style={{ fontSize: 11 }}>
                                    Active
                                </span></Tag> : <Tag color="red" style={{ float: 'right', borderRadius: 5 }} >
                                <span className="textStyles-small" style={{ fontSize: 11 }}>
                                    Deactive
                                </span></Tag>
                              }
                          </div>
                          <div style={{ marginBottom: 8 }}>
                            <span className="textStyles-small">Category</span>
                            <Tag color="purple" style={{ float: 'right', borderRadius: 5 }} tooltip="This is a required field">
                              <span className="textStyles-small" style={{ fontSize: 11 }}>
                                {generator?.category?.name}
                              </span></Tag>
                          </div>
                          <Divider style={{ marginTop: '3px' }} />
                          <Button
                            type="primary"
                            style={{ marginRight: 8, borderRadius: '5px' }}
                            size='small'
                            onClick={() => this.viewMoreDetails(generator)}>
                            <span className="textStyles-small" style={{ fontSize: 10 }}> <i class="mdi mdi mdi-unfold-more-horizontal"></i> More Details</span>
                          </Button>

                          {checkPermissions('SITE_VIEW_GENERAL_USER') || checkPermissions('SITE_VIEW_ADMIN_USER') ? (
                          <Button
                            icon={<EditOutlined style={{ color: 'white' }} />}
                            style={{ marginRight: 8, float: 'right', borderRadius: 5, backgroundColor: '#F28502', borderColor: '#F28502' }}
                            onClick={() => this.grnUpdata(generator.id)}
                            size='small'
                          />): ('')}
                          
                          <Popconfirm
                            title={<span className='textStyles-small' style={{ fontSize: 14 }}>Are you sure to delete this Asset?</span>}
                            description={<span className="textStyles-small">Are you sure to delete this Asset?</span>}
                            onConfirm={() => this.submitForm(generator?.id)}
                            okText="Yes"
                            cancelText="No"
                          >
                            { checkPermissions('SITE_VIEW_ADMIN_USER') ? (
                                <Button
                                  icon={<DeleteOutlined style={{ color: 'white' }} />}
                                  danger
                                  size='small'
                                  style={{ marginRight: 8, float: 'right', borderRadius: 5, backgroundColor: '#BA183A', borderColor: '#BA183A' }}
                                />
                              )
                              : ('')}
                          </Popconfirm>
        
                        </Card>
                      </Col>
                    ))}
                </Row>

                <Drawer
                    maskClosable={false}
                    title={<span className="textStyles-small" style={{ fontSize: 14 }}>Generator Details</span>}
                    width={"50%"}
                    placement="right"
                    onClose={() => this.onViewMoreDetailsDrawerClose()}
                    visible={this.state.openGenDetails}
                    closeIcon={<button type="button"
                        class="btn btn-soft-danger btn-icon-square-sm"
                        style={{ marginRight: "8px" }}><i class="mdi dripicons-cross"></i></button>}>
                    <Collapse
                        style={{ alignContent: "center", borderColor: "white" }}
                    >
                        {columns2.map((item, index) => (
                            <Panel
                                style={{
                                    borderColor: index % 2 === 0 ? "#f8f9fa" : "white",
                                    backgroundColor: index % 2 === 0 ? "#f8f9fa" : "white"
                                }}
                                header={
                                    <li className="d-flex justify-content-between align-items-center"
                                        style={{ backgroundColor: index % 2 === 0 ? "#f8f9fa" : "white" }}>
                                        <div>
                                            <span className="textStyles-small">{item.title}</span>
                                        </div>
                                        <span className="textStyles-small">{item.content}</span>
                                    </li>
                                }
                                key={item.title}
                                showArrow={item.details.length > 0}
                                collapsible={item.details.length > 0 ? "" : "icon"}
                            >
                                {item.details.map((detail) => (
                                    <li
                                        className="d-flex justify-content-between align-items-center me-2"
                                        style={{ paddingBottom: "10px", paddingLeft: "10px" }}
                                        key={detail.title}
                                    >
                                        <div>
                                            <span className='textStyles-small'>{detail.title}</span>
                                        </div>
                                        <span className="textStyles-small">{detail.content}</span>
                                    </li>
                                ))}
                            </Panel>
                        ))}
                    </Collapse>
                </Drawer>

                {/* popup start */}
                <Drawer maskClosable={false} title={<span className="textStyles-small" style={{ fontSize: 14 }}>New Generator</span>}
                width={"60%"} placement="right" onClose={() => this.onDrawerClose()} 
                visible={this.state.open} closeIcon={<button type="button" 
                class="btn btn-soft-danger btn-icon-square-sm" style={{ marginRight: "8px" }}>
                    <i class="mdi dripicons-cross"></i></button>}>
                    <div className="row" >
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <Form ref={this.formRef}>
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Name<x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Generator_Name" tooltip="This is a required field">
                                                    <Input id="Generator_Name" defaultValue={"Generator-"} onChange={this.handleGenName} />
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Name', this.state.genName, 'required')}</p>
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Make <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Makw" tooltip="This is a required field">
                                                    <Select
                                                        showSearch
                                                        // onChange={this.onChangeTowerType}
                                                        onChange={this.onChangeGeneratorMake}
                                                        style={{ width: "100%" }}
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                        }
                                                    >
                                                        {this.props?.genMasterDataSet?.genMake?.map((item, index) => {
                                                            return <Option value={item.id}>{item.name}</Option>;
                                                        })}

                                                    </Select>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Model', this.state.selectedGeneratorMakeId, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Model <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Model" tooltip="This is a required field">
                                                    <Select
                                                        showSearch
                                                        // onChange={this.onChangeTowerType}
                                                        onChange={this.onChangeGeneratormodel}

                                                        style={{ width: "100%" }}
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                        }
                                                    >
                                                        {this.state.modelList?.map((item, index) => {
                                                            return <Option value={item.id}>{item.name}</Option>;
                                                        })}

                                                    </Select>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Model', this.state.selectedGeneratormodelId, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Capacity(kVA) <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Generator_Capacity" >
                                                    {/* <InputNumber style={{ width: '100%' }} id="Generator_Capacity" onChange={this.handleGenCapacity} /> */}
                                                    <div>
                                                        <Select
                                                            id='Generator_Capacity'
                                                            style={{ width: "100%" }}
                                                            showSearch
                                                            onChange={(e) => {
                                                                this.handleGenCapacity(e)
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["genCapacity"]?.map((x, y) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Capacity', this.state.genCapacity, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Generator SAP Serial Number <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="GeneratorSAPSerialNumber" >
                                                    <Input style={{ width: '100%' }} id="GeneratorSAPSerialNumber" onChange={this.handleGenSAPSerialNumber} />
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('SAP Serial Number', this.state.SAPSerialNumber, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Engine Serial Number <x style={{ color: "red" }}>*</x>
                                                </label>

                                                <Form.Item required name="Engine Serial Number" >
                                                    <Input style={{ width: '100%' }} id="Generator_Status" onChange={this.handleEngineSerialNumber} />
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Engine Serial Number', this.state.engineSerialNumber, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Alternater Serial Number <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Alternater Serial Number" >
                                                    <Input style={{ width: '100%' }} id="Generator_Status" onChange={this.handleAlternaterSerialNumber} />
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Alternater Serial Number', this.state.alternaterSerialNumber, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Controller Serial Number <x style={{ color: "red" }}>*</x>
                                                </label>

                                                <Form.Item required name="Controller Serial Number" >
                                                    <Input style={{ width: '100%' }} id="Generator_Status" onChange={this.handleControllerSerialNumber} />
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Controller Serial Number', this.state.controllerSerialNumber, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Engine Model <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Engine Model" >
                                                    <div>
                                                        <Select
                                                            style={{ width: '100%' }}
                                                            showSearch
                                                            onChange={(e) => {
                                                                this.handlegeneratorEngineModel(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["genEngineModel"].map((x) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Engine Model', this.state.engineModel, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            {/* <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Generator Controller Model <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Generator Controller Model" >
                                                    <div>
                                                        <Select
                                                            showSearch
                                                            style={{ width: "100%" }}
                                                            onChange={(e) => {
                                                                this.handlegeneratorControllerModel(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["generatorControllerModel"].map((x) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Generator Controller Model', this.state.generatorControllerModel, 'required')}</p>
                                                </Form.Item>
                                            </div> */}
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Engine Controller Model <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Engine Controller Model" >
                                                    {/* <Input style={{ width: '100%' }} id="Generator Controller Model" onChange={this.handlegeneratorControllerModel} /> */}
                                                    <div>
                                                        <Select
                                                            showSearch
                                                            style={{ width: "100%" }}
                                                            onChange={(e) => {
                                                                this.handleengineControllerModel(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["generatorControllerModel"].map((x) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Engine Controller Model', this.state.engineControllerModel, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    AVR Model <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Generator_Status" >
                                                    <div>
                                                        <Select
                                                            showSearch
                                                            style={{ width: '100%' }}
                                                            onChange={(e) => {
                                                                this.handlegeneratorAVRModel(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["avrModel"].map((x) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('AVR Model', this.state.avrModel, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Fuel Tank Capacity (l) <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Fuel Tank Capacity" >
                                                    {/* <InputNumber style={{ width: '100%' }} id="Fuel Tank Capacity" onChange={this.handlefuelTankCapacity} /> */}
                                                    <div>
                                                        <Select
                                                            style={{ width: '100%' }}
                                                            onChange={(e) => {
                                                                this.handlefuelTankCapacity(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["fuelTankCapacity"].map((x) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Fuel Tank Capacity', this.state.fuelTankCapacity, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Type <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Type" tooltip="This is a required field">
                                                    <Select
                                                        showSearch
                                                        // onChange={this.onChangeTowerType}
                                                        onChange={this.onChangeGeneratorType}

                                                        style={{ width: "100%" }}
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                        }
                                                    >
                                                        {this.state.tankTypesList?.map((item, index) => {
                                                            return <Option value={item.id}>{item.name}</Option>;
                                                        })}

                                                    </Select>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Type', this.state.selectedGeneratorTypeId, 'required')}</p>

                                                </Form.Item>
                                            </div>

                                            {this.state.selectedGeneratorTypeId == 2 ? (
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <label className="form-label" for="depot">
                                                            Gen Bulk Tank <x style={{ color: "red" }}>*</x>
                                                        </label>
                                                        <Form.Item >

                                                            <Select
                                                                showSearch
                                                                // onChange={this.onChangeTowerType}
                                                                onChange={this.onChangeGenBulckTank}

                                                                style={{ width: "100%" }}
                                                                placeholder="Search to Select"
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                filterSort={(optionA, optionB) =>
                                                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                                }
                                                            >
                                                                {this.state.bulckTankList?.map((item, index) => {
                                                                    return <Option value={item.id}>{"Capacity: " + item.capacity + " / Max Filling Limit: " + item.maxFillingLimit}</Option>;
                                                                })}

                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                </div>) : ("")
                                            }

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Average Running Hours per month
                                                </label>
                                                <Form.Item required name="Average Running Hours per month " >
                                                    <InputNumber style={{ width: '100%' }} id="Average Running Hours per month " onChange={this.handlAverageRunningHourspermonth} />
                                                    {/* <p style={{ color: "#f5325c" }}>{this.validator.message('Generator cool down delay time', this.state.generatorCoolDownDelayTime, 'required')}</p> */}
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Phase1 Load (A) <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Phase1 Load" tooltip="This is a required field">
                                                    <InputNumber style={{ width: '100%' }} id="Phase1 Load" onChange={this.handlephase1Load} />
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Phase1 Load', this.state.phase1Load, 'required')}</p>
                                                </Form.Item>

                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Phase2 Load (A) <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Phase2 Load" >
                                                    <InputNumber style={{ width: '100%' }} id="Phase2 Load" onChange={this.handlephase2Load} />
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Phase2 Load', this.state.phase2Load, 'required')}</p>
                                                </Form.Item>

                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Phase3 Load (A) <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Phase3 Load" tooltip="This is a required field">
                                                    <InputNumber style={{ width: '100%' }} id="Phase3 Load" onChange={this.handlephase3Load} />
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Phase3 Load', this.state.phase3Load, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Hour Meter Reading (Hrs) <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Fuel Tank Capacity" >
                                                    <InputNumber style={{ width: '100%' }} id="Fuel Tank Capacity" onChange={this.handlehourMeterReading} />
                                                    {/* <p style={{ color: "#f5325c" }}>{this.validator.message('Fuel Tank Capacity', this.state.hourMeterReading, 'required')}</p> */}
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Available Fuel Quantity (l) <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Available Fuel Quantity" >
                                                    <InputNumber style={{ width: '100%' }} id="Available Fuel Quantity" onChange={this.handleavailableFuelQty} />
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Available Fuel Quantity', this.state.availableFuelQty, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Actual Fuel Consumption Rate (Litres/Hour)
                                                </label>
                                                <Form.Item required name="Actual Fuel Consumption Rate" >
                                                    <InputNumber style={{ width: '100%' }} id="Actual Fuel Consumption Rate" onChange={this.handleactualFuelConsumptionRate} />
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Availability Of Gen Canapy <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item >
                                                    <div>
                                                        <Select
                                                            style={{ width: "100%" }}
                                                            onChange={(e) => {
                                                                this.onChangeAvailabilityOfGenCanapy(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["availabilityOfGenCanapy"]?.map((x, y) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                </Form.Item>
                                                <p style={{ color: "#f5325c" }}>{this.validator.message('Availability Of Gen Canapy', this.state.availabilityOfGenCanapy, 'required')}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Gen Canapy Status <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Gen Canapy Status" >
                                                    {/* <Input style={{ width: '100%' }} id="Gen Canapy Status" onChange={this.handlegenCanapyStatus} /> */}
                                                    <div>
                                                        <Select
                                                            style={{ width: "100%" }}
                                                            onChange={(e) => {
                                                                this.handlegenCanapyStatus(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["genCanapyStatus"].map((x, y) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Gen Canapy Status', this.state.genCanapyStatus, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Sound Proof Status <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Sound Proof Status" >
                                                    {/* <Input style={{ width: '100%' }} id="Sound Proof Status" onChange={this.handlesoundProofStatus} /> */}
                                                    <div>
                                                        <Select
                                                            style={{ width: "100%" }}
                                                            onChange={(e) => {
                                                                this.handlesoundProofStatus(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["soundProofStatus"].map((x, y) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Sound Proof Status', this.state.soundProofStatus, 'required')}</p>
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Delay Timer Status <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Delay Timer Status" >
                                                    {/* <Input style={{ width: '100%' }} id="Delay Timer Status" onChange={this.handlDelayTimerStatus} /> */}
                                                    <div>
                                                        <Select
                                                            style={{ width: "100%" }}
                                                            onChange={(e) => {
                                                                this.handlDelayTimerStatus(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["delayTimerStatus"].map((x, y) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Delay Timer Status', this.state.delayTimerStatus, 'required')}</p>
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Generator start up delay time (min) <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Generator Worm-Up Delay Time" >
                                                    <InputNumber style={{ width: '100%' }} id="Generator Worm-Up Delay Time" onChange={this.handlegeneratorWormUpDelayTime} />
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Generator Worm-Up Delay Time Status', this.state.generatorWormUpDelayTime, 'required')}</p>
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Generator cool down delay time (min) <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Generator cool down delay time" >
                                                    <InputNumber style={{ width: '100%' }} id="Generator cool down delay time" onChange={this.handlegeneratorCoolDownDelayTime} />
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Generator cool down delay time', this.state.generatorCoolDownDelayTime, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    RMS Integrated Status
                                                </label>
                                                <Form.Item required name="Rm sintegrated Status" >
                                                    <div>
                                                        <Select
                                                            style={{ width: "100%" }}
                                                            onChange={(e) => {
                                                                this.handlermsintegratedStatus(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["rmsintegratedStatus"].map((x, y) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    RMS Inband/Outband
                                                </label>
                                                <Form.Item required name="RMS Inband Outband" >
                                                    {/* <Input style={{ width: '100%' }} id="RMS Inband Outband" onChange={this.handlerMsInbandOutband} /> */}
                                                    <div>
                                                        <Select
                                                            style={{ width: "100%" }}
                                                            onChange={(e) => {
                                                                this.handlerMsInbandOutband(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["rmsInbandOutband"].map((x, y) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    RMS Connection Method
                                                </label>
                                                <Form.Item required name="Rms Connection Method" >
                                                    <div>
                                                        <Select
                                                            style={{ width: "100%" }}
                                                            onChange={(e) => {
                                                                this.handlermsconnectionMethod(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["rmsConnectionMethod"].map((x, y) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    RMS related SIM Number
                                                </label>
                                                <Form.Item required name="Rm Srelated SIM Number" >
                                                    <Input style={{ width: '100%' }} id="Rm Srelated SIM Number" onChange={this.handlerMSRelatedSIMNumber} />
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Last Serviced Date
                                                </label>
                                                <Form.Item required name="Last Serviced Date" >
                                                    <DatePicker
                                                        style={{ width: "100%" }}
                                                        onChange={this.onChangeLastServicedDate}
                                                    />
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Installed Date
                                                </label>
                                                <Form.Item required name="Installed Date" >
                                                    <DatePicker
                                                        style={{ width: "100%" }}
                                                        onChange={this.onChangeInstalledDate}
                                                    />
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Is Active<x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Is_active" tooltip="This is a required field">
                                                    <Select
                                                        showSearch
                                                        onChange={this.onChangeGeneratorIsActive}

                                                        style={{ width: "100%" }}
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                        }
                                                    >
                                                        <Option value='1'>Yes</Option>
                                                        <Option value='0'>No</Option>

                                                    </Select>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Is active', this.state.generatorIsActive, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Category <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Category" tooltip="This is a required field">
                                                    <Select
                                                        showSearch
                                                        // onChange={this.onChangeTowerType}
                                                        onChange={this.onChangeGeneratorCategory}

                                                        style={{ width: "100%" }}
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                        }
                                                    >
                                                        {this.state.categoriesList?.map((item, index) => {
                                                            return <Option value={item.id}>{item.name}</Option>;
                                                        })}

                                                    </Select>

                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Category', this.state.selectedGeneratorCategory, 'required')}</p>
                                                </Form.Item>

                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Max Filling Limit <x style={{ color: "red" }}>*</x>
                                                </label>
                                                <Form.Item required name="Generator_MaxFillingLimit" tooltip="This is a required field">
                                                    <InputNumber style={{ width: '100%' }} id="Generator_MaxFillingLimit" onChange={this.handleMaxFillingLimit} />
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Max Filling Limit', this.state.genMaxFillingLimit, 'required')}</p>
                                                </Form.Item>

                                            </div>


                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Description
                                                </label>
                                                <Form.Item required name="Generator_Description" tooltip="This is a required field">
                                                    <Input id="Generator_Description" onChange={this.handleGenDescription} />
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    Warranty Expired Date
                                                </label>
                                                <Form.Item required name=" Warranty Expired Date" >
                                                    <DatePicker
                                                        style={{ width: "100%" }}
                                                        onChange={this.onChangeWarrantyExpiredDate}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </Form>
                                    <div className='row' style={{ justifyContent: "end" }}>
                                        <div className='col-md-2' >   <button className="btn btn-primary" onClick={() => this.AllDataSubmit()} >
                                            Add New Asset
                                        </button></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </Drawer>

                {/* Genarator Edit Section */}
                <Drawer maskClosable={false}
                    title={!this.state.isUpadetQuery ? 
                    <span className="textStyles-small"
                        style={{ fontSize: 14 }}>New Generator</span> :
                        <span style={{ fontSize: 14 }}
                            className="textStyles-small">Edit Generator</span>}
                    width={"50%"}
                    placement="right"
                    onClose={() => this.onDrawerCloseEdit()}
                    visible={this.state.openEdit}
                    closeIcon={<button type="button" class="btn btn-soft-danger btn-icon-square-sm"
                        style={{ marginRight: "8px" }}><i class="mdi dripicons-cross"></i></button>}>
                    <div className="row" >
                        <div className="col-lg-12">
                            <div className="card" style={{ borderColor: "white" }}>
                                <div className="card-body">
                                    <Form
                                        ref={this.formRef}
                                    >
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Name<x style={{ color: "red" }}>*</x>
                                                    </span>
                                                </label>
                                                <Form.Item >
                                                    <Input id="Generator_Name" value={this.state.genName} onChange={this.handleGenName} className='borderedSelect' style={{ height: 34 }} />
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('Name', this.state.genName, 'required')}</p>
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Make <x style={{ color: "red" }}>*</x>
                                                    </span>
                                                </label>
                                                {this.state.selectedGeneratorMakeId != null ? (
                                                    <Form.Item required name="Make" tooltip="This is a required field">
                                                        <Select
                                                            showSearch
                                                            onChange={this.onChangeGeneratorMake}
                                                            defaultValue={this.state.selectedGeneratorMakeId}
                                                            className='borderedSelect'
                                                            bordered={false}
                                                            style={{ width: "100%" }}
                                                            placeholder="Search to Select"
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            filterSort={(optionA, optionB) =>
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                            }
                                                        >
                                                            {this.props?.genMasterDataSet?.genMake?.map((item, index) => {
                                                                return <Option value={item.id}>{item.name}</Option>;
                                                            })}

                                                        </Select>
                                                        <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                            {this.validator.message('Model', this.state.selectedGeneratorMakeId, 'required')}</p>
                                                    </Form.Item>) : ('')}
                                                {this.state.selectedGeneratorMakeId == null ? (<Form.Item required name="Makw" tooltip="This is a required field">
                                                    <Select
                                                        showSearch
                                                        onChange={this.onChangeGeneratorMake}
                                                        className='borderedSelect'
                                                        bordered={false}
                                                        style={{ width: "100%" }}
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                        }
                                                    >
                                                        {this.props?.genMasterDataSet?.genMake?.map((item, index) => {
                                                            return <Option value={item.id}>{item.name}</Option>;
                                                        })}

                                                    </Select>
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('Model', this.state.selectedGeneratorMakeId, 'required')}</p>
                                                </Form.Item>) : ('')}
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Model <x style={{ color: "red" }}>*</x>
                                                    </span>
                                                </label>
                                                {this.state.selectedGeneratormodelId != null ? (<Form.Item><Select
                                                    showSearch
                                                    className='borderedSelect'
                                                    bordered={false}
                                                    onChange={this.onChangeGeneratormodel}
                                                    defaultValue={this.state.selectedGeneratormodelId}
                                                    style={{ width: "100%" }}
                                                    placeholder="Search to Select"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                    }
                                                >
                                                    {this.state.modelList?.map((item, index) => {
                                                        return <Option value={item.id}>{item.name}</Option>;
                                                    })}

                                                </Select></Form.Item>) : (
                                                    <Form.Item required name="Model" tooltip="This is a required field">
                                                        <Select
                                                            showSearch
                                                            className='borderedSelect'
                                                            bordered={false}
                                                            onChange={this.onChangeGeneratormodel}
                                                            style={{ width: "100%" }}
                                                            placeholder="Search to Select"
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            filterSort={(optionA, optionB) =>
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                            }
                                                        >
                                                            {this.state.modelList?.map((item, index) => {
                                                                return <Option value={item.id}>{item.name}</Option>;
                                                            })}

                                                        </Select>
                                                    </Form.Item>
                                                )}
                                                <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                    {this.validator.message('Model', this.state.selectedGeneratormodelId, 'required')}</p>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Capacity(kVA)
                                                    </span>
                                                </label>
                                                <Form.Item>
                                                    <div>
                                                        <Select
                                                            value={this.state.genCapacity}
                                                            showSearch
                                                            id='Generator_Capacity'
                                                            style={{ width: "100%" }}
                                                            className='borderedSelect'
                                                            bordered={false}
                                                            onChange={(e) => {
                                                                this.handleGenCapacity(e)
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["genCapacity"]?.map((x, y) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('Capacity', this.state.genCapacity, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Generator SAP Serial Number <x style={{ color: "red" }}>*</x>
                                                    </span>
                                                </label>
                                                <Form.Item>
                                                    <Input style={{ width: '100%', height: 34 }} id="GeneratorSAPSerialNumber"
                                                        className='borderedSelect'
                                                        value={this.state.SAPSerialNumber} onChange={this.handleGenSAPSerialNumber} />
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('SAP Serial Number', this.state.SAPSerialNumber, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Engine Serial Number <x style={{ color: "red" }}>*</x>
                                                    </span>
                                                </label>
                                                <Form.Item >
                                                    <Input style={{ width: '100%', height: 34 }} className='borderedSelect' id="Generator_Status" value={this.state.engineSerialNumber} onChange={this.handleEngineSerialNumber} />
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('Engine Serial Number', this.state.engineSerialNumber, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Alternater Serial Number <x style={{ color: "red" }}>*</x>
                                                    </span>
                                                </label>
                                                <Form.Item  >
                                                    <Input style={{ width: '100%', height: 34 }} className='borderedSelect' id="Generator_Status" value={this.state.alternaterSerialNumber} onChange={this.handleAlternaterSerialNumber} />
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('Alternater Serial Number', this.state.alternaterSerialNumber, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Controller Serial Number <x style={{ color: "red" }}>*</x>
                                                    </span>
                                                </label>
                                                <Form.Item>
                                                    <Input style={{ width: '100%', height: 34 }} className='borderedSelect' value={this.state.controllerSerialNumber} id="Generator_Status" onChange={this.handleControllerSerialNumber} />
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('Controller Serial Number', this.state.controllerSerialNumber, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Engine Model <x style={{ color: "red" }}>*</x>
                                                    </span>
                                                </label>
                                                <Form.Item >
                                                    <div>
                                                        <Select
                                                            className='borderedSelect'
                                                            bordered={false}
                                                            showSearch
                                                            value={this.state.engineModel}
                                                            style={{ width: '100%' }}
                                                            onChange={(e) => {
                                                                this.handlegeneratorEngineModel(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["genEngineModel"].map((x) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('Engine Model', this.state.engineModel, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Engine Controller Model <x style={{ color: "red" }}>*</x>
                                                    </span>
                                                </label>
                                                <Form.Item required name="Engine Controller Model" >
                                                    <div>
                                                        <Select
                                                            className='borderedSelect'
                                                            bordered={false}
                                                            value={this.state.engineControllerModel}
                                                            showSearch
                                                            style={{ width: "100%" }}
                                                            onChange={(e) => {
                                                                this.handleengineControllerModel(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["generatorControllerModel"].map((x) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('Engine Controller Model', this.state.engineControllerModel, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        AVR Model <x style={{ color: "red" }}>*</x>
                                                    </span>
                                                </label>
                                                <Form.Item required name="AVR Model" >
                                                    <div>
                                                        <Select
                                                            showSearch
                                                            value={this.state.avrModel}
                                                            className='borderedSelect'
                                                            bordered={false}
                                                            style={{ width: '100%' }}
                                                            onChange={(e) => {
                                                                this.handlegeneratorAVRModel(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["avrModel"].map((x) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('AVR Model', this.state.avrModel, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Fuel Tank Capacity (l) <x style={{ color: "red" }}>*</x>
                                                    </span>
                                                </label>
                                                <Form.Item  >
                                                    <div>
                                                        <Select
                                                            value={this.state.fuelTankCapacity}
                                                            style={{ width: '100%' }}
                                                            className='borderedSelect'
                                                            bordered={false}
                                                            onChange={(e) => {
                                                                this.handlefuelTankCapacity(e);
                                                            }}>
                                                            {this.props.genDropdown["generatorDropDownObject"]["fuelTankCapacity"].map((x) => {
                                                                return <Option value={x}>{x}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('Fuel Tank Capacity', this.state.fuelTankCapacity, 'required')}</p>
                                                </Form.Item>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Type <x style={{ color: "red" }}>*</x>
                                                    </span>
                                                </label>
                                                {this.state.selectedGeneratorTypeId != null ? (<Form.Item><Select
                                                    showSearch
                                                    onChange={this.onChangeGeneratorType}
                                                    defaultValue={this.state.selectedGeneratorTypeId}
                                                    style={{ width: "100%" }}
                                                    placeholder="Search to Select"
                                                    className='borderedSelect'
                                                    bordered={false}
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                    }
                                                >
                                                    {this.state.tankTypesList?.map((item, index) => {
                                                        return <Option value={item.id}>{item.name}</Option>;
                                                    })}

                                                </Select></Form.Item>) : (
                                                    <Form.Item required name="Type" tooltip="This is a required field"><Select
                                                        showSearch
                                                        onChange={this.onChangeGeneratorType}
                                                        style={{ width: "100%" }}
                                                        placeholder="Search to Select"
                                                        className='borderedSelect'
                                                        bordered={false}
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                        }
                                                    >
                                                        {this.state.tankTypesList?.map((item, index) => {
                                                            return <Option value={item.id}>{item.name}</Option>;
                                                        })}

                                                    </Select></Form.Item>
                                                )}
                                                <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                    {this.validator.message('Type', this.state.selectedGeneratorTypeId, 'required')}</p>
                                                {this.state.selectedGeneratorTypeId == 2 ? (
                                                    <div className='row'>
                                                        <div className='col-md-6'>
                                                            <label className="form-label" for="depot">
                                                                <span className="textStyles-small">
                                                                    Gen Bulk Tank <x style={{ color: "red" }}>*</x>
                                                                </span>
                                                            </label>
                                                            {this.state.selectedGenBulckTankId != null ? (<Form.Item><Select
                                                                showSearch
                                                                onChange={this.onChangeGenBulckTank}
                                                                defaultValue={this.state.selectedGenBulckTankId}
                                                                style={{ width: '100%' }}
                                                                className='borderedSelect'
                                                                bordered={false}
                                                                placeholder="Search to Select"
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                filterSort={(optionA, optionB) =>
                                                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                                }
                                                            >
                                                                {this.state.bulckTankList?.map((item, index) => {
                                                                    return <Option value={item.id}>{"Capacity: " + item.capacity + " / Max Filling Limit: " + item.maxFillingLimit}</Option>;
                                                                })}

                                                            </Select></Form.Item>) : ('')}
                                                            {this.state.selectedGenBulckTankId == null ? (<Form.Item><Select
                                                                showSearch
                                                                onChange={this.onChangeGenBulckTank}
                                                                style={{ width: "100%" }}
                                                                placeholder="Search to Select"
                                                                className='borderedSelect'
                                                                bordered={false}
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                filterSort={(optionA, optionB) =>
                                                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                                }
                                                            >
                                                                {this.state.bulckTankList?.map((item, index) => {
                                                                    return <Option value={item.id}>{"Capacity: " + item.capacity + " / Max Filling Limit: " + item.maxFillingLimit}</Option>;
                                                                })}
                                                            </Select></Form.Item>) : ('')}
                                                        </div>
                                                    </div>) : ("")}

                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label" for="depot">
                                                    <span className="textStyles-small">
                                                        Average Running Hours per month
                                                    </span>
                                                </label>
                                                <Form.Item >
                                                    <InputNumber style={{ width: '100%', height: 34 }} className='borderedSelect' value={this.state.genAverageRunningHourspermonth} id="Average Running Hours per month " onChange={this.handlAverageRunningHourspermonth} />
                                                    {/* <p style={{ color: "#f5325c" }}>{this.validator.message('Generator cool down delay time', this.state.generatorCoolDownDelayTime, 'required')}</p> */}
                                                </Form.Item>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Phase1 Load (A) <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    <Form.Item required name="Phase1 Load" tooltip="This is a required field">
                                                        <InputNumber value={this.state.phase1Load} style={{ width: '100%', height: 34 }} className='borderedSelect' id="Phase1 Load" onChange={this.handlephase1Load} />
                                                        <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                            {this.validator.message('Phase1 Load', this.state.phase1Load, 'required')}</p>
                                                    </Form.Item>

                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Phase2 Load (A) <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    <Form.Item required name="Phase2 Load" >
                                                        <InputNumber value={this.state.phase2Load} style={{ width: '100%', height: 34 }} className='borderedSelect' id="Phase2 Load" onChange={this.handlephase2Load} />
                                                        <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                            {this.validator.message('Phase2 Load', this.state.phase2Load, 'required')}</p>
                                                    </Form.Item>

                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Phase3 Load (A) <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    <Form.Item required name="Phase3 Load" tooltip="This is a required field">
                                                        <InputNumber value={this.state.phase3Load} style={{ width: '100%', height: 34 }} className='borderedSelect' id="Phase3 Load" onChange={this.handlephase3Load} />
                                                        <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                            {this.validator.message('Phase3 Load', this.state.phase3Load, 'required')}</p>
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Hour Meter Reading (Hrs) <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    <Form.Item >
                                                        <InputNumber style={{ width: '100%', height: 34 }} className='borderedSelect' value={this.state.hourMeterReading} id="Fuel Tank Capacity" onChange={this.handlehourMeterReading} />
                                                        {/* <p style={{ color: "#f5325c" }}>{this.validator.message('Fuel Tank Capacity', this.state.hourMeterReading, 'required')}</p> */}
                                                    </Form.Item>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Available Fuel Quantity (l) <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    <Form.Item required name="Available Fuel Quantity" >
                                                        <InputNumber value={this.state.availableFuelQty} style={{ width: '100%', height: 34 }} className='borderedSelect' id="Available Fuel Quantity" onChange={this.handleavailableFuelQty} />
                                                        <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                            {this.validator.message('Available Fuel Quantity', this.state.availableFuelQty, 'required')}</p>
                                                    </Form.Item>
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Actual Fuel Consumption Rate (Litres/Hour)
                                                        </span>
                                                    </label>
                                                    <Form.Item  >
                                                        <InputNumber value={this.state.actualFuelConsumptionRate} style={{ width: '100%', height: 34 }} className='borderedSelect' id="Actual Fuel Consumption Rate" onChange={this.handleactualFuelConsumptionRate} />
                                                    </Form.Item>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Availability Of Gen Canapy <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    <Form.Item >
                                                        <div>
                                                            <Select
                                                                value={this.state.availabilityOfGenCanapy}
                                                                className='borderedSelect'
                                                                bordered={false}
                                                                style={{ width: "100%" }}
                                                                onChange={(e) => {
                                                                    this.onChangeAvailabilityOfGenCanapy(e);
                                                                }}>
                                                                {this.props.genDropdown["generatorDropDownObject"]["availabilityOfGenCanapy"]?.map((x, y) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('Availability Of Gen Canapy', this.state.availabilityOfGenCanapy, 'required')}</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Gen Canapy Status <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    <Form.Item  >
                                                        <div>
                                                            <Select
                                                                value={this.state.genCanapyStatus?.toString()}
                                                                className='borderedSelect'
                                                                bordered={false}
                                                                style={{ width: "100%" }}
                                                                onChange={(e) => {
                                                                    this.handlegenCanapyStatus(e);
                                                                }}>
                                                                {this.props.genDropdown["generatorDropDownObject"]["genCanapyStatus"]?.map((x, y) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                        <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                            {this.validator.message('Gen Canapy Status', this.state.genCanapyStatus, 'required')}</p>
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Sound Proof Status <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    <Form.Item  >
                                                        <div>
                                                            <Select
                                                                value={this.state.soundProofStatus}
                                                                style={{ width: "100%" }}
                                                                className='borderedSelect'
                                                                bordered={false}
                                                                onChange={(e) => {
                                                                    this.handlesoundProofStatus(e);
                                                                }}>
                                                                {this.props.genDropdown["generatorDropDownObject"]["soundProofStatus"]?.map((x, y) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                        <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                            {this.validator.message('Sound Proof Status', this.state.soundProofStatus, 'required')}</p>
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Delay Timer Status <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    <Form.Item  >
                                                        <div>
                                                            <Select
                                                                value={this.state.delayTimerStatus}
                                                                style={{ width: "100%" }}
                                                                className='borderedSelect'
                                                                bordered={false}
                                                                onChange={(e) => {
                                                                    this.handlDelayTimerStatus(e);
                                                                }}>
                                                                {this.props.genDropdown["generatorDropDownObject"]["delayTimerStatus"].map((x, y) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                        <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                            {this.validator.message('Delay Timer Status', this.state.delayTimerStatus, 'required')}</p>
                                                    </Form.Item>
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Generator start up delay time (min) <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    <Form.Item  >
                                                        <InputNumber value={this.state.generatorWormUpDelayTime} style={{ width: '100%', height: 34 }} className='borderedSelect' id="Generator Worm-Up Delay Time" onChange={this.handlegeneratorWormUpDelayTime} />
                                                        <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                            {this.validator.message('Generator Worm-Up Delay Time Status', this.state.generatorWormUpDelayTime, 'required')}</p>
                                                    </Form.Item>
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Generator cool down delay time (min) <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    <Form.Item required name="Generator cool down delay time" >
                                                        <InputNumber value={this.state.generatorCoolDownDelayTime} style={{ width: '100%', height: 34 }} className='borderedSelect' id="Generator cool down delay time" onChange={this.handlegeneratorCoolDownDelayTime} />
                                                        <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                            {this.validator.message('Generator cool down delay time', this.state.generatorCoolDownDelayTime, 'required')}</p>
                                                    </Form.Item>
                                                </div>

                                            </div>

                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" >
                                                        <span className="textStyles-small">
                                                            RMS Integrated Status
                                                        </span>
                                                    </label>
                                                    <Form.Item >
                                                        <div>
                                                            <Select
                                                                value={this.state.rmsintegratedStatus}
                                                                style={{ width: "100%" }}
                                                                className='borderedSelect'
                                                                bordered={false}
                                                                onChange={(e) => {
                                                                    this.handlermsintegratedStatus(e);
                                                                }}>
                                                                {this.props.genDropdown["generatorDropDownObject"]["rmsintegratedStatus"]?.map((x, y) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            RMS Inband/Outband
                                                        </span>
                                                    </label>
                                                    <Form.Item >
                                                        <div>
                                                            <Select
                                                                value={this.state.rmsInbandOutband}
                                                                className='borderedSelect'
                                                                bordered={false}
                                                                style={{ width: "100%" }}
                                                                onChange={(e) => {
                                                                    this.handlerMsInbandOutband(e);
                                                                }}>
                                                                {this.props.genDropdown["generatorDropDownObject"]["rmsInbandOutband"].map((x, y) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            RMS Connection Method
                                                        </span>
                                                    </label>
                                                    <Form.Item  >
                                                        <div>
                                                            <Select
                                                                value={this.state.rmsconnectionMethod}
                                                                className='borderedSelect'
                                                                bordered={false}
                                                                style={{ width: "100%" }}
                                                                onChange={(e) => {
                                                                    this.handlermsconnectionMethod(e);
                                                                }}>
                                                                {this.props.genDropdown["generatorDropDownObject"]["rmsConnectionMethod"].map((x, y) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            RMS related SIM Number
                                                        </span>
                                                    </label>
                                                    <Form.Item >
                                                        <Input value={this.state.rmsrelatedSIMNumber} style={{ width: '100%', height: 34 }} className='borderedSelect' id="Rm Srelated SIM Number" onChange={this.handlerMSRelatedSIMNumber} />
                                                    </Form.Item>
                                                </div>

                                            </div>

                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Last Serviced Date
                                                        </span>
                                                    </label>
                                                    {this.state.lastServicedDate != null ? (<Form.Item required name="Last Serviced Date" >
                                                        <DatePicker
                                                            style={{ width: '100%', height: 34 }} className='borderedSelect'
                                                            defaultValue={this.state.lastServicedDate != '' ? (moment(this.state.lastServicedDate)) : ("")}
                                                            onChange={this.onChangeLastServicedDate}
                                                        />
                                                    </Form.Item>) : (
                                                        <Form.Item required name="Last Serviced Date" >
                                                            <DatePicker
                                                                style={{ width: '100%', height: 34 }} className='borderedSelect'
                                                                onChange={this.onChangeLastServicedDate}
                                                            />
                                                        </Form.Item>
                                                    )}
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Installed Date
                                                        </span>
                                                    </label>
                                                    {this.state.installedDate != null ? (
                                                        <Form.Item required name="Installed Date" >
                                                        <DatePicker
                                                            style={{ width: '100%', height: 34 }} className='borderedSelect'
                                                            defaultValue={this.state.installedDate != '' ? (moment(this.state.installedDate)) : ("")}
                                                            onChange={this.onChangeInstalledDate}
                                                        />
                                                    </Form.Item>) : (
                                                        <Form.Item required name="Installed Date" >
                                                            <DatePicker
                                                                style={{ width: '100%', height: 34 }} className='borderedSelect'
                                                                onChange={this.onChangeInstalledDate}
                                                            />
                                                        </Form.Item>
                                                    )}
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Is Active<x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    {this.state.generatorIsActive != null ? (
                                                        <Form.Item >
                                                            <Select
                                                                showSearch
                                                                defaultValue={(this.state.generatorIsActive).toString()}
                                                                onChange={this.onChangeGeneratorIsActive}
                                                                className='borderedSelect'
                                                                bordered={false}
                                                                style={{ width: "100%" }}
                                                                placeholder="Search to Select"
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                filterSort={(optionA, optionB) =>
                                                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                                }
                                                            >
                                                                <Option value='1'>Yes</Option>
                                                                <Option value='0'>No</Option>
                                                            </Select>
                                                        </Form.Item>) : (
                                                        <Form.Item required name="Is Active" >
                                                            <Select
                                                                showSearch
                                                                className='borderedSelect'
                                                                bordered={false}
                                                                onChange={this.onChangeGeneratorIsActive}
                                                                style={{ width: "100%" }}
                                                                placeholder="Search to Select"
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                filterSort={(optionA, optionB) =>
                                                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                                }
                                                            >
                                                                <Option value='1'>Yes</Option>
                                                                <Option value='0'>No</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    )}
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('Is active', this.state.generatorIsActive, 'required')}</p>
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Category <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    {this.state.selectedGeneratorCategory != null ? (<Form.Item><Select
                                                        showSearch
                                                        className='borderedSelect'
                                                        bordered={false}
                                                        onChange={this.onChangeGeneratorCategory}
                                                        defaultValue={this.state.selectedGeneratorCategory}
                                                        style={{ width: "100%" }}
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                        }
                                                    >
                                                        {this.state.categoriesList?.map((item, index) => {
                                                            return <Option value={item.id}>{item.name}</Option>;
                                                        })}

                                                    </Select></Form.Item>) : (
                                                        <Form.Item required name="Category" ><Select
                                                            showSearch
                                                            className='borderedSelect'
                                                            bordered={false}
                                                            onChange={this.onChangeGeneratorCategory}
                                                            style={{ width: "100%" }}
                                                            placeholder="Search to Select"
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            filterSort={(optionA, optionB) =>
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                            }
                                                        >
                                                            {this.state.categoriesList?.map((item, index) => {
                                                                return <Option value={item.id}>{item.name}</Option>;
                                                            })}
                                                        </Select></Form.Item>
                                                    )}
                                                    <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                        {this.validator.message('Category', this.state.selectedGeneratorCategory, 'required')}</p>
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Max Filling Limit <x style={{ color: "red" }}>*</x>
                                                        </span>
                                                    </label>
                                                    <Form.Item>
                                                        <InputNumber style={{ width: '100%', height: 34 }} className='borderedSelect' value={this.state.genMaxFillingLimit} id="Generator_MaxFillingLimit" onChange={this.handleMaxFillingLimit} />
                                                        <p style={{ color: "#f5325c", marginTop: 5 }} className='textStyles-small'>
                                                            {this.validator.message('Max Filling Limit', this.state.genMaxFillingLimit, 'required')}</p>
                                                    </Form.Item>
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Description
                                                        </span>
                                                    </label>
                                                    <Form.Item >
                                                        <Input id="Generator_Description" value={this.state.genDescription} onChange={this.handleGenDescription} style={{ width: '100%', height: 34 }} className='borderedSelect' />
                                                    </Form.Item>

                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        <span className="textStyles-small">
                                                            Warranty Expired Date
                                                        </span>
                                                    </label>
                                                    {this.state.WarrantyExpiredDate != null ? (
                                                        <Form.Item required name=" Warranty Expired Date2" ><DatePicker
                                                            defaultValue={this.state.WarrantyExpiredDate != '' ? (moment(this.state.WarrantyExpiredDate)) : ("")}
                                                            style={{ width: '100%', height: 34 }} className='borderedSelect'
                                                            onChange={this.onChangeWarrantyExpiredDate}
                                                        /></Form.Item>) : (
                                                        <Form.Item required name=" Warranty Expired Date" ><DatePicker
                                                            style={{ width: '100%', height: 34 }} className='borderedSelect'
                                                            onChange={this.onChangeWarrantyExpiredDate}
                                                        /></Form.Item>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row' style={{ justifyContent: "end" }}>
                                            <div className='col-md-2' style={{ borderColor: '#BA183A', backgroundColor: '#BA183A', borderRadius: '5px', float: 'right' }}>
                                                {
                                                    this.state.isUpadetQuery ? (
                                                        <Button className="btn btn-primary"
                                                            style={{ borderColor: '#BA183A', backgroundColor: '#BA183A', borderRadius: '5px', float: 'right' }}
                                                            onClick={() => this.AllDataSubmitToUpdate()} >
                                                            <span className="textStyles-small" style={{ color: 'white' }}>
                                                                Update This Asset
                                                            </span>
                                                        </Button>
                                                    ) : (
                                                        <Button className="btn btn-primary"
                                                            style={{ borderColor: '#BA183A', backgroundColor: '#BA183A', borderRadius: '5px', float: 'right' }}
                                                            onClick={() => this.AllDataSubmit()} >
                                                            <span className="textStyles-small" style={{ color: 'white' }}>
                                                                Add This Asset
                                                            </span>
                                                        </Button>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </Drawer>
            </div>
        );
    }
}

export default GeneratorDetails;